import IncreamentHistory from "../features/employees/IncreamentHistory"

const IncreamentHistoryPage = () => {
    return (
        <>
            <IncreamentHistory />
        </>
    )
}

export default IncreamentHistoryPage